import "../css/login.css";

const Register = ({ onRedirect }) => {
  return (
    <div>
      <h2 className="text-center default-box-title">Đăng ký</h2>
      {/* <Form>
        <Form.Group className="mb-3">
          <Form.Label>
            <i className="far fa-user"></i> Tên tài khoản
          </Form.Label>
          <Form.Control type="text" placeholder="Nhập email" />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            <i className="fas fa-key"></i> Mật khẩu
          </Form.Label>
          <InputGroup className="mb-2">
            <Form.Control
              id="inlineFormInputGroup"
              type={showPass ? 'text' : 'password'}
              placeholder="Nhập mật khẩu"
            />
            <InputGroup.Text onClick={() => setShowPass(!showPass)}>
              <i className={showPass ? 'far fa-eye-slash' : 'far fa-eye'}></i>
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>

        <Form.Check
          type="checkbox"
          id="autoSizingCheck2"
          style={{ color: 'var(--dark-gray' }}
          label="Ghi nhớ tôi"
        />

        <div className="d-flex justify-content-center align-items-center mb-3">
          <button type="submit" className="mb-2 btn-submit">
            Đăng ký
          </button>
        </div>
      </Form>*/}
      <div className="login-with-google mb-3">
        {/*  <div className="border-line d-flex justify-content-center align-items-center ">
          <div className="line"></div>
          <div className="line-text"> HOẶC </div>
          <div className="line"></div>
        </div>*/}
        <div className="d-flex justify-content-center align-items-center">
          <button className="d-flex justify-content-center align-items-center">
            Đăng ký với Google{" "}
            <img src="/images/icons/google-logo.png" alt="Đăng ký với Google" />
          </button>
        </div>
      </div>

      <p className="text-center m-0">
        <span>Bạn đã có tài khoản? </span>
        <span className="registration-redirect" onClick={() => onRedirect()}>
          Đăng nhập
        </span>
      </p>
    </div>
  );
};
export default Register;
